<script lang="ts" setup>
	export type IconLibProps = {
		icon: string
		dir: string
		stroke?: string
		rectStroke?: string
		circleStroke?: string
		fill?: string
		height?: number | string
		width?: number | string
		number?: number
		pathFill?: string
		rectFill?: string
		className?: ClassContext
		pathClass?: string[] | string | object
		rectClass?: string[] | string | object
		svgClass?: string[] | string | object
		circleFill?: string
		circleClass?: string[] | object[] | string | object
		viewbox?: string
	}
	const iconProps = defineProps<IconLibProps>()
	const customize = (content: string) => {
		if (iconProps.pathClass) {
			return content.replaceAll(/<path/g, `<path class="${iconProps.pathClass}"`)
		}
		if (iconProps.circleClass) {
			return content.replaceAll(/<circle/g, `<circle class="${iconProps.circleClass}"`)
		}
		if (iconProps.rectClass) {
			return content.replaceAll(/<rect/g, `<rect class="${iconProps.rectClass}"`)
		}

		if (iconProps.stroke) {
			return content
				.replace(/stroke="[^"]*"/g, `stroke="${iconProps.stroke}"`)
				.replace(/fill="[^"]*"/g, `fill="none"`)
		}
		if (iconProps.pathFill) {
			return content
				.replace(/fill="[^"]*"/g, `fill="${iconProps.pathFill}"`)
				.replace(/stroke="[^"]*"/g, 'stroke="none"')
		}
	}
</script>

<template>
	<span>
		<Icon
			mode="svg"
			:height="iconProps?.height || 18"
			:width="iconProps?.width || 18"
			:name="`${String(dir)}:${String(icon)}`"
			:class="svgClass"
			:customize
		/>
	</span>
</template>
